import React from 'react'

import { Box, Button, Container, Divider, LazyImage, Text } from '@doist/marketist'

import { UserStoryBox } from 'components/UserStoryBox/UserStoryBox'
import { useTranslation } from 'next-i18next'
import { Customer } from 'types/contentful'

import { Percentages } from './Percentages'

import css from './CustomerStories.module.css'

type Props = {
    customers: Customer[]
}

function CustomerStories({ customers }: Props) {
    const { t } = useTranslation(['customers'])

    return (
        <Container className={css.container}>
            <Box tag="section" className={css.heroSection}>
                <Box className={css.illustration}>
                    <LazyImage
                        alt={t('illustrationAlt')}
                        src="/assets/customer-stories/illustration-header.jpg"
                    />
                </Box>
                <Text tag="h1" className={css.header} size="major-3xl">
                    {t('header')}
                </Text>
            </Box>
            <Box tag="section" className={css.percentageContainer}>
                <Text tag="h2" className={css.title} size="minor-lg" weight="bold">
                    {t('whySwitch')}
                </Text>
                <Percentages />
            </Box>
            {customers.map((customer) => (
                <Box className={css.customerContainer} key={customer.id}>
                    <UserStoryBox customer={customer} />
                    <figure className={css.quoteCarousel}>
                        <Text tag="figcaption" size="minor-base" className={css.attribute}>
                            {customer.attribution}
                        </Text>
                        <blockquote>
                            <Text size="major-sm" className={css.quote}>
                                {customer.quote}
                            </Text>
                        </blockquote>
                    </figure>
                </Box>
            ))}
            <Divider separator className={css.divider} />
            <Box tag="section" className={css.ctaFooter}>
                <Text tag="h2" size="major-xl">
                    {t('ctaFooter.title')}
                </Text>
                <Text tag="p" size="body-lg">
                    {t('ctaFooter.subtitle')}
                </Text>
                <Button href="/home">{t('ctaFooter.buttonText')}</Button>
            </Box>
        </Container>
    )
}

export { CustomerStories }
